import React, {useState} from "react"
import {useHierarchicalMenu} from "react-instantsearch"
import ShowMore from "@bodeboca/algolia/components/filters/show-more"
import {useTranslation} from "react-i18next"

type Props = {
  title: string;
  attributes: any;
  sortBy: any;
  showMore: boolean;
  limit: number;
  showMoreLimit: number;
  isAlgolia: boolean;
};
const HierarchicalMenuFilter = ({title, showMore, attributes, showMoreLimit, limit}: Props) => {
  const {t} = useTranslation()
  const [open, setOpen] = useState(false)
  // For sample. Pending decision.
  const {
    items,
    isShowingMore,
    refine,
    toggleShowMore,
    createURL
  } = useHierarchicalMenu({
    attributes,
    showMoreLimit,
    sortBy: ["count:desc"],
    showMore,
    limit: 3
  })

  function HierarchicalList({items, createURL, onNavigate}) {
    if (items.length === 0) {
      return null
    }

    return (<ul className="ais-Menu-list dropdown-menu">
      {items.map((item) => (
        <li className="ais-Menu-item dropdown-menu-item" key={item.value}>
          <a
            className="ais-Menu-link"
            href={createURL(item.value)}
            style={{fontWeight: item.isRefined ? "bold" : "normal"}}
            onClick={(event) => {
              event.preventDefault()
              setOpen(!open)
              onNavigate(item.value)
            }}>
            <span className="ais-Menu-label">{item.label}</span>
            <span className="ais-Menu-count">{item.count}</span>
          </a>
          {item.data && <HierarchicalList
            items={item.data}
            onNavigate={onNavigate}/>}
        </li>))}
    </ul>)
  }

  return (<>
    {items.length > 1 && <div
      className={"bb-filter-options " + (open ? "filter-options-mobile-open" : "")}>
      <h4 className="bb-filter-processed" onClick={() => setOpen(!open)}>
        {t(title)}
      </h4>
      <div className="ais-Menu item-list">
        <HierarchicalList
          items={items}
          onNavigate={refine}/>
        {showMore && <ShowMore
          isShowingMore={isShowingMore}
          showMore={showMore}
          toggleShowMore={toggleShowMore}/>}
      </div>
    </div>}
  </>)
}

export default HierarchicalMenuFilter
